import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ActionModalHeader from "./ActionModalHeader";

export interface ConfirmAction {
  icon: string;
  tone: "blue" | "ok" | "warn" | "bad";
  title: string;
  body: string;
  confirmLabel: string;
  danger?: boolean;
  onConfirm: (reason: string) => void;
}

interface ConfirmActionModalProps {
  action: ConfirmAction | null;
  onHide: () => void;
}

// Generic "are you sure?" modal with an optional reason (activate, deactivate, trash…)
const ConfirmActionModal = ({ action, onHide }: ConfirmActionModalProps) => {
  const [reason, setReason] = useState("");
  useEffect(() => { if (action) setReason(""); }, [action]);

  return (
    <Modal show={!!action} onHide={onHide} centered contentClassName="cx">
      {action && <>
        <ActionModalHeader icon={action.icon} tone={action.tone} title={action.title} subtitle={action.body} onClose={onHide} />
        <div style={{ padding: "14px 20px" }}>
          <label className="cx-label">Reason <span className="muted" style={{ fontWeight: 400 }}>(optional)</span></label>
          <textarea className="cx-input" rows={2} placeholder="e.g. Multiple spam reports from Meta" value={reason} onChange={(e) => setReason(e.target.value)}></textarea>
        </div>
        <div style={{ padding: "0 20px 18px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button type="button" className="cx-btn cx-btn-light" onClick={onHide}>Cancel</button>
          <button type="button" className={`cx-btn ${action.danger ? "cx-btn-danger" : "cx-btn-primary"}`} onClick={() => action.onConfirm(reason.trim())}>
            {action.confirmLabel}
          </button>
        </div>
      </>}
    </Modal>
  );
};

export default ConfirmActionModal;
